// Angular Files
import { Pipe, PipeTransform } from '@angular/core';

const STATUS_BADGE_MAP: Record<string, string> = {
    // Success
    Finalized: 'status-badge--success',
    Completed: 'status-badge--success',
    CompletedSuccessfully: 'status-badge--success',

    // Warning
    PendingReview: 'status-badge--warning',
    Pending: 'status-badge--warning',

    // Neutral
    Active: 'status-badge--neutral',
    Processing: 'status-badge--neutral',
    Processed: 'status-badge--neutral',
    Posting: 'status-badge--neutral',
    Posted: 'status-badge--neutral',
    Abandoned: 'status-badge--neutral',

    // Muted
    Scheduled: 'status-badge--muted',

    // Error
    Refunded: 'status-badge--error',
    Cancelled: 'status-badge--error',
    Canceled: 'status-badge--error',
    PostingFailed: 'status-badge--error',
    ProcessingFailed: 'status-badge--error',
    ValidationFailed: 'status-badge--error',
    NotCompletedSuccessfully: 'status-badge--error',
    Failed: 'status-badge--error'
};

@Pipe({
    name: 'statusBadge',
    standalone: false
})
export class StatusBadgePipe implements PipeTransform {
    transform(status: string): string {
        return STATUS_BADGE_MAP[status] ?? '';
    }
}
